module.exports = "/packs/images/our-perspective/mobile/hero@2x-c2cc961f324e6f6d23f192f73d774be2.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/our-perspective/mobile/hero@2x.jpg
// module id = 1786
// module chunks = 0